import React from "react";
import "./about.css";
import aboutImg1 from "../assets/img/about-1.jpg";
import aboutImg2 from "../assets/img/about-2.jpg";
import aboutImg3 from "../assets/img/about-3.jpg";
import bgVideo from "../assets/img/about-bg.mp4"; // background video

const About = () => {
  return (
    <section className="about-section">
      {/* 🔹 Background Video */}
      <video className="bg-video" autoPlay loop muted playsInline>
        <source src={bgVideo} type="video/mp4" />
      </video>

      <div className="overlay-bg"></div>

      {/* 🔹 Main Content */}
      <div className="about-content">
        <h2 className="about-title">About MarketMind4U</h2>

        {/* ✅ Typewriter Tagline */}
        <div className="typewriter-container">
          <h3 className="typewriter">
            Grow Your Business with MarketMind4U 🚀
          </h3>
        </div>

        <p className="about-text">
          At <strong>MarketMind4U</strong>, we’re not just another digital
          marketing agency — we’re your <strong>growth accelerator</strong>.
          Our vision is to empower brands with next-gen{" "}
          <strong>AI-driven marketing, creative storytelling,</strong> and
          strategic innovations that help businesses{" "}
          <strong>Grow Smart & Fast</strong>.
        </p>

        <p className="about-text">
          From <strong>SEO, Social Media & AI Ads</strong> to complete digital
          transformation, we deliver solutions that inspire trust and drive
          measurable growth. Our team fuses{" "}
          <strong>creativity, technology, and strategy</strong> to elevate your
          brand’s journey.
        </p>
      </div>

      {/* 🔹 3 Image Gallery */}
      <div className="about-gallery">
        {[
          { img: aboutImg1, title: "Digital Strategy" },
          { img: aboutImg2, title: "Creative Innovation" },
          { img: aboutImg3, title: "Marketing Excellence" },
        ].map((item, index) => (
          <div className="image-card" key={index}>
            <img src={item.img} alt={item.title} className="about-image" />
            <div className="overlay">
              <h3>{item.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default About;
